import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from 'react-query';
import { Food, Menu, MenuDraft, User, Vote } from './types';
import { addFood, getFood } from './food';
import { addFoodToMenu, deleteFoodFromMenu, getMenu } from './menu';
import { vote } from './vote';
import { AxiosError } from 'axios';
import { getUser } from './user';

export const useCreateFood = (
  options?: UseMutationOptions<unknown, AxiosError, Food>
) =>
  useMutation({
    mutationFn: addFood,
    ...options,
  });

export const useFoodQuery = (options?: UseQueryOptions<Food[], Error>) =>
  useQuery({
    queryKey: ['food'],
    queryFn: async () => getFood(),
    ...options,
  });

export const useMenuQuery = (options?: UseQueryOptions<Menu[], Error>) =>
  useQuery({
    queryKey: ['menu'],
    queryFn: async () => getMenu(),
    ...options,
  });

export const useCreateMenu = (
  options?: UseMutationOptions<MenuDraft, AxiosError, MenuDraft>
) =>
  useMutation({
    mutationFn: addFoodToMenu,
    ...options,
  });

export const useVoteMutation = (
  options?: UseMutationOptions<unknown, AxiosError, Vote>
) =>
  useMutation({
    mutationFn: vote,
    ...options,
  });

export const useDeleteFoodFromMenu = (
  options?: UseMutationOptions<unknown, AxiosError, string>
) =>
  useMutation({
    mutationFn: deleteFoodFromMenu,
    ...options,
  });

export const useUserQuery = (options?: UseQueryOptions<User, Error>) =>
  useQuery({
    queryKey: ['user'],
    queryFn: async () => getUser(),
    ...options,
  });
